import { type RecordOf, isRecord } from 'immutable';

import { ReportConfigurationProps, mkReportConfiguration } from './reportConfigurationsTypes';

export function transformReportConfigurationToRequestData(
  reportConfiguration: ReportConfigurationProps | RecordOf<ReportConfigurationProps>,
): ReportConfigurationProps {
  if (isRecord(reportConfiguration)) {
    return reportConfiguration.toJS() as ReportConfigurationProps;
  }

  const requestData = {
    id: reportConfiguration.id,
    clientId: reportConfiguration.clientId,

    name: reportConfiguration.name,
    description: reportConfiguration.description,

    accountingType: reportConfiguration.accountingType,
    reportType: reportConfiguration.reportType,
    reportSubType: reportConfiguration.reportSubType,
    persistentType: reportConfiguration.persistentType,

    dateRange: reportConfiguration.dateRange,
    startOn: reportConfiguration.startOn,
    endOn: reportConfiguration.endOn,

    columnType: reportConfiguration.columnType,
    rowType: reportConfiguration.rowType,
    timestep: reportConfiguration.timestep,

    showTotalRows: reportConfiguration.showTotalRows,

    filterId: reportConfiguration.filterId,
    filter: reportConfiguration.filter,

    displayOptions: reportConfiguration.displayOptions,
    chartType: reportConfiguration.chartType,

    isDeleted: reportConfiguration.isDeleted,
  };

  return requestData;
}

export const transformResponseToReportConfigurations = (
  response?: { data?: { resources?: ReportConfigurationProps[] } } | null,
): RecordOf<ReportConfigurationProps>[] | null | undefined => {
  if (!response || !response.data || !response.data.resources) {
    return null;
  }

  const reportConfig = response?.data?.resources?.map((data) =>
    mkReportConfiguration({
      id: data.id,
      clientId: data.clientId,

      name: data.name,
      description: data.description,

      accountingType: data.accountingType,
      reportType: data.reportType,
      reportSubType: data.reportSubType,
      persistentType: data.persistentType,

      dateRange: data.dateRange,
      startOn: data.startOn,
      endOn: data.endOn,

      columnType: data.columnType,
      rowType: data.rowType,
      timestep: data.timestep,

      filter: data.filter,
      filterId: data.filterId,

      displayOptions: data.displayOptions ?? {
        alternateRows: false,
        density: 'STANDARD',
        hideCents: false,
        showExpensesAsNegative: false,
        showRowNumbers: false,
        showOtherOnTop: false,
        showSubTotalsOnTop: false,
      },
      chartType: data.chartType,

      isDeleted: data.isDeleted,
      modifiedAt: data.modifiedAt,
    }),
  );

  return reportConfig || [];
};
